import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import attentionApi from '@/features/dashboard/attention/api/attentionApi.ts';
import { resolveAttentionFindingsRequestMapper } from '@/features/dashboard/attention/types/ResolveAttentionFindingsRequest.mapper.ts';
import { invalidateAttentionQueries } from '@/utils/invalidateAttentionQueries.ts';

export interface ResolveAttentionFindingsParams {
  findingIds: string[];
  comment?: string;
  /** Wyjazd, którego panel ma się odświeżyć; brak przy sprawach firmy. */
  tourId?: string;
}

/**
 * Odłożenie wsadu spraw. Toast sukcesu składa wołający — musi w nim usiąść
 * „Cofnij”, a tylko dialog wie, które id przywrócić.
 */
export const useResolveAttentionFindings = () => {
  const queryClient = useQueryClient();

  return useMutation<void, Error, ResolveAttentionFindingsParams>({
    mutationFn: ({ findingIds, comment }) =>
      attentionApi.resolve(
        resolveAttentionFindingsRequestMapper.fromFormToDto({
          findingIds,
          comment,
        }),
      ),
    onSuccess: (_, { tourId }) =>
      invalidateAttentionQueries(queryClient, tourId),
    onError: (error) =>
      toast.error('Nie udało się odłożyć sprawy', {
        description: error.message,
      }),
  });
};

export default useResolveAttentionFindings;
